import { keepPreviousData, queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ScenarioItemFilters } from '@/lib/api/adaptive-planner/scenarioItemFilters';
import { LoopPlannerTimelineItemsApi } from '@/lib/api/loop-planner/timeline-items';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const getTimelineItemsDataSetQueryOptions = ({
  loopId,
  scenarioId,
  filters,
}: {
  loopId: number;
  scenarioId: number;
  filters?: ScenarioItemFilters;
}) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.timelineItems.dataSet({ loopId, scenarioId, filters }),
    queryFn: () => LoopPlannerTimelineItemsApi.getDataSet({ loopId, scenarioId, filters }),
  });

export const useGetTimelineItemsDataSetSuspenseQuery = ({
  loopId,
  scenarioId,
  filters,
}: {
  loopId: number;
  scenarioId: number;
  filters?: ScenarioItemFilters;
}) => {
  return useSuspenseQuery(getTimelineItemsDataSetQueryOptions({ loopId, scenarioId, filters }));
};

export const useGetTimelineItemsDataSetQuery = ({
  loopId,
  scenarioId,
  filters,
}: {
  loopId: number;
  scenarioId: number;
  filters?: ScenarioItemFilters;
}) => {
  return useQuery({
    ...getTimelineItemsDataSetQueryOptions({ loopId, scenarioId, filters }),
    placeholderData: keepPreviousData,
  });
};
